export default function (entity) {

    this.$.world.remove(entity);
};
